import gql from 'graphql-tag';
import { executeMutation } from '../client';

const PERFORM_SELECTIONS_UPDATE_MUTATION = gql`
  mutation performSelectionUpdate($selectedIds: [String]!, $unselectedIds: [String]!) {
    performSelections(purchaseConditionIds: $selectedIds)
    performUnselections(purchaseConditionIds: $unselectedIds)
  }
`;

export async function performSelectionsUpdate(
  selectedIds: string[],
  unselectedIds: string[]
): Promise<{ selectedCount: number; unselectedCount: number }> {
  const updateResult = await executeMutation<{ performSelections: number; performUnselections: number }>(
    PERFORM_SELECTIONS_UPDATE_MUTATION,
    {
      selectedIds,
      unselectedIds
    }
  );
  return {
    selectedCount: updateResult?.performSelections ?? 0,
    unselectedCount: updateResult?.performUnselections ?? 0
  };
}
